import './assets/styles/main.scss';
import FrontdeskRoutes from './routes/FrontdeskRoutes';

export default FrontdeskRoutes;
